import React from 'react';
import PropTypes from 'prop-types';

const ReviewFilter = ({ filters, onFilterSelected }) => (
  <div className="review-filter">
    {filters.map(btn => (
      <span className="container-menu-button">
        <button
          key={`index_${btn.filter}`}
          type="button"
          // className={`menu-button${btn.active === true ? ' active' : ''}`}
          className="menu-button active"
          onClick={() => onFilterSelected(btn.filter)}
        >
          <span>{btn.title}</span>
        </button>
      </span>
    ))}
  </div>
);

ReviewFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    filter: PropTypes.string,
    active: PropTypes.bool,
  })).isRequired,
  onFilterSelected: PropTypes.func.isRequired,
};

export default ReviewFilter;
